import React, {  useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import musicposters from '../SanatanBeats/BeatsPoster/beatsposter';
import track1 from '../SanatanBeats/m1.mp3';
import track2 from '../SanatanBeats/m2.mp3';
import track3 from '../SanatanBeats/m3.mp3';

import track4 from '../SanatanBeats/m4.mp3';
import track5 from '../SanatanBeats/m5.mp3';
import track6 from '../SanatanBeats/m6.mp3';

import track7 from '../SanatanBeats/m7.mp3';
import track8 from '../SanatanBeats/m8.mp3';
import track9 from '../SanatanBeats/m9.mp3';

import track10 from '../SanatanBeats/m10.mp3';
import track11 from '../SanatanBeats/m11.mp3';
import track12 from '../SanatanBeats/m12.mp3';

import track13 from '../SanatanBeats/m13.mp3';
import track14 from '../SanatanBeats/m14.mp3';
import track15 from '../SanatanBeats/m15.mp3';

import track16 from '../SanatanBeats/m16.mp3';
import track17 from '../SanatanBeats/m17.mp3';
import track18 from '../SanatanBeats/m18.mp3';

import track19 from '../SanatanBeats/m19.mp3';
import track20 from '../SanatanBeats/m20.mp3';
import track21 from '../SanatanBeats/m21.mp3';

import track22 from '../SanatanBeats/m22.mp3';
import track23 from '../SanatanBeats/m23.mp3';
import track24 from '../SanatanBeats/m24.mp3';

import track25 from '../SanatanBeats/m25.mp3';
import track26 from '../SanatanBeats/m26.mp3';
import track27 from '../SanatanBeats/m27.mp3';

import track28 from '../SanatanBeats/m28.mp3';
import track29 from '../SanatanBeats/m29.mp3';
import track30 from '../SanatanBeats/m30.mp3';

import track31 from '../SanatanBeats/m31.mp3';
import track32 from '../SanatanBeats/m32.mp3';
import track33 from '../SanatanBeats/m33.mp3';

import track34 from '../SanatanBeats/m34.mp3';
import track35 from '../SanatanBeats/m35.mp3';
import track36 from '../SanatanBeats/m36.mp3';

import track37 from '../SanatanBeats/m37.mp3';
import track38 from '../SanatanBeats/m38.mp3';
import track39 from '../SanatanBeats/m39.mp3';
import track40 from '../SanatanBeats/m40.mp3';

import '../../Zone/zone.css';
import '../../Zone/musicposter.css';

function BeatsMusic() {
  const navigate = useNavigate();
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);

  const tracks = [
    { id: 1, title: 'KANCHUKA KA KHEL!.mp3', audio: track1, musicposter:musicposters.poster1},
    { id: 2, title: 'Mool Mantar Di Awaaz.mp3', audio: track2, musicposter:musicposters.poster2 },
    { id: 3, title: 'Why Not Peace Buddhism.mp3', audio: track3, musicposter:musicposters.poster3 },
    { id: 4, title: 'सुनो मेरी बात.mp3', audio: track4, musicposter:musicposters.poster4 },
    { id: 5, title: 'Main Yugo Mein Ghoomta Gaya.mp3', audio: track5, musicposter:musicposters.poster5 },
    { id: 6, title: 'कल्प वृक्ष की सवारी.mp3', audio: track6, musicposter:musicposters.poster6 },
    { id: 7, title: 'चलो बच्चों, विनायक के संग!.mp3', audio: track7, musicposter:musicposters.poster7 },
    { id: 8, title: 'ज्ञानेश्वरी गीत_ जीवनाचा रंग.mp3', audio: track8, musicposter:musicposters.poster8 },
    { id: 9, title: 'Anusuya Jagaran Igniting the PARBRAHMAN Within.mp3', audio: track9, musicposter:musicposters.poster9 },
    { id: 10, title: 'I Am Not, I Am That.mp3', audio: track10, musicposter:musicposters.poster10 },
    { id: 11, title: 'Ik Onkar Satya Yuga Geet (Transliteration).mp3', audio: track11, musicposter:musicposters.poster11 },
    { id: 12, title: 'Main Meera bhi hoon, Kalki bhi_A Fusion of Prem & Dharma — To Krishna.mp3', audio: track12, musicposter:musicposters.poster12 },
    { id: 13, title: 'Nashid Asr al-Haqq_ Nida al-Mahdi_(Song of Satya Yuga_ The Call of the Mahdi.mp3', audio: track13, musicposter:musicposters.poster13 },
    { id: 14, title: 'Noor-e-Haq.mp3', audio: track14, musicposter:musicposters.poster14 },
    { id: 15, title: 'PASSIONIT का दिव्य जागरण_(Hinglaj Devi से Kalki तक का जागरण गीत).mp3', audio: track15, musicposter:musicposters.poster15 },
    { id: 16, title: 'Forgotten Roots.mp3', audio: track16, musicposter:musicposters.poster16 },
    { id: 17, title: 'SATYA YUGA SONG_KALKIS CALL.mp3', audio: track17, musicposter:musicposters.poster17 },
    { id: 18, title: 'Shakti Awakens Satya Yuga Call (Transliteration).mp3', audio: track18, musicposter:musicposters.poster18 },
    { id: 19, title: 'Should I Die Again.mp3', audio: track19, musicposter:musicposters.poster19 },
    { id: 20, title: 'Song Return of Jesus.mp3', audio: track20, musicposter:musicposters.poster20 },
    { id: 21, title: 'छोटा सनातन गीत .mp3', audio: track21, musicposter:musicposters.poster21 },
    { id: 22, title: 'योगमाया का जागरण.mp3', audio: track22, musicposter:musicposters.poster22 },
    { id: 23, title: 'राधा-कृष्ण का प्रेम, कल्कि की सीख.mp3', audio: track23, musicposter:musicposters.poster23 },
    { id: 24, title: 'राम-सिया प्रीत गीत.mp3', audio: track24, musicposter:musicposters.poster24 },
    { id: 25, title: 'सत्य युग का गीत_ कल्कि का आह्वान.mp3', audio: track25, musicposter:musicposters.poster25 },
    { id: 26, title: 'Light of One.mp3', audio: track26, musicposter:musicposters.poster26 },
    { id: 27, title: 'HARE RAMA, HARE KRISHNA.mp3', audio: track27, musicposter:musicposters.poster27 },
    { id: 28, title: 'सांख्य बोले गिन-गिन रे.mp3', audio: track28, musicposter:musicposters.poster28 },
    { id: 29, title: 'Dhamman.mp3', audio: track29, musicposter:musicposters.poster29 },
    { id: 30, title: 'Gayatri with Shree Suktam.mp3', audio: track30, musicposter:musicposters.poster30},
    { id: 31, title: 'Kahan Aaya Hun.mp3', audio: track31, musicposter:musicposters.poster31 },
    { id: 32, title: 'PASSIONIT ASHTALAKSHMI.mp3', audio: track32, musicposter:musicposters.poster32 },
    { id: 33, title: 'PASSIONIT PRUTL Parabrahma, Prakriti & Kalki _.mp3', audio: track33, musicposter:musicposters.poster33 },
    { id: 34, title: 'Qurbani.mp3', audio: track34, musicposter:musicposters.poster34 },
    { id: 35, title: 'SANANTAN various raga.mp3', audio: track35, musicposter:musicposters.poster35 },
    { id: 36, title: 'SHAKTI-BHAIRAV.mp3', audio: track36, musicposter:musicposters.poster36 },
    { id: 37, title: 'Universal Prayer of Karma, Compassion, and Creation.mp3', audio: track37, musicposter:musicposters.poster37 },
    { id: 38, title: 'Where have I come.mp3', audio: track38, musicposter:musicposters.poster38 },
    { id: 39, title: 'YinYang Harmony.mp3', audio: track39, musicposter:musicposters.poster39 },
    { id: 40, title: 'Maha Kalki Kreem Shloka Song.mp3', audio: track40, musicposter:musicposters.poster40 },
  ];

    useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      const updateTimer = () => setCurrentTime(audio.currentTime);
      const setTrackDuration = () => setDuration(audio.duration);
      audio.addEventListener('timeupdate', updateTimer);
      audio.addEventListener('loadedmetadata', setTrackDuration);

      return () => {
        audio.removeEventListener('timeupdate', updateTimer);
        audio.removeEventListener('loadedmetadata', setTrackDuration);
      };
    }
  }, [selectedTrack]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60) || 0;
    const seconds = Math.floor(time % 60) || 0;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div style={{ backgroundColor: 'black', minHeight: '100vh', padding: '20px', color: 'white' }}>
      {!selectedTrack ? (
        <>
          <h1 className="zone-title">🎵 Music Library</h1>
          <div className="episodes-grid">
            {tracks.map((track) => (
              <div key={track.id} className="episode-card" onClick={() => setSelectedTrack(track)}>
                <div className="episode-thumbnail">
                  <img src={track.musicposter} alt={track.title} className="music-poster" />
                  <span className="episode-number">🎶</span>
                  <span className="music-tooltip">{track.title}</span>
                </div>
                <p className="episode-title">{track.title}</p>
              </div>
            ))}
          </div>
          <Link to="/zones" className="back-button">⬅ Back to Museum Realms</Link>
        </>
      ) : (
        <div className="video-player-container">
          <h2>{selectedTrack.title}</h2>
         <audio
            ref={audioRef}
            controls
            autoPlay
            onEnded={() => setSelectedTrack(null)}
            style={{ width: '80%', maxWidth: '600px', margin: '20px 0' }}
            >
            <source src={selectedTrack.audio} type="audio/mp3" />
            Your browser does not support the audio element.
            </audio>

          <p>{formatTime(currentTime)} / {formatTime(duration)}</p>
          <button className="back-button" onClick={() => setSelectedTrack(null)}>⬅ Back to Music</button>
        </div>
      )}
    </div>
  );
}

export default BeatsMusic;

